var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock6Months(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_641_5763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9002 23.5995C10.9002 23.7995 3.60023 26.5995 3.70023 29.8995C3.80023 33.1995 11.2002 35.5995 20.2002 35.3995C29.2002 35.1995 36.5002 32.3995 36.4002 29.0995C36.3002 25.7995 28.9002 23.3995 19.9002 23.5995Z",
    fill: "url(#paint0_linear_641_5763)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1453 35.3977C29.2 35.1764 36.4758 32.3563 36.3962 29.0988C36.3166 25.8413 28.9117 23.38 19.857 23.6013C10.8022 23.8226 3.52645 26.6427 3.60606 29.9002C3.68568 33.1577 11.0905 35.619 20.1453 35.3977Z",
    stroke: "url(#paint1_linear_641_5763)",
    strokeWidth: 0.55,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8996 26.8999C26.3996 26.6999 31.7996 28.4999 31.7996 30.8999C31.8996 33.1999 26.5996 35.2999 20.0996 35.3999C13.5996 35.4999 8.19963 33.7999 8.19963 31.3999C8.09963 29.0999 13.3996 26.9999 19.8996 26.8999Z",
    fill: "url(#paint2_linear_641_5763)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1023 35.3006C26.6173 35.1414 31.8528 33.1324 31.7961 30.8135C31.7394 28.4946 26.4121 26.7439 19.897 26.9031C13.382 27.0623 8.14653 29.0712 8.2032 31.3901C8.25987 33.709 13.5873 35.4598 20.1023 35.3006Z",
    stroke: "url(#paint3_linear_641_5763)",
    strokeWidth: 0.19,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 0.5V35.3",
    stroke: "url(#paint4_linear_641_5763)",
    strokeWidth: 0.19,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5V35.3",
    stroke: "url(#paint5_linear_641_5763)",
    strokeWidth: 0.19,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6996 28.8992C22.2401 28.8992 24.2996 26.8397 24.2996 24.2992C24.2996 21.7587 22.2401 19.6992 19.6996 19.6992C17.1591 19.6992 15.0996 21.7587 15.0996 24.2992C15.0996 26.8397 17.1591 28.8992 19.6996 28.8992Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6996 28.8992C22.2401 28.8992 24.2996 26.8397 24.2996 24.2992C24.2996 21.7587 22.2401 19.6992 19.6996 19.6992C17.1591 19.6992 15.0996 21.7587 15.0996 24.2992C15.0996 26.8397 17.1591 28.8992 19.6996 28.8992Z",
    stroke: "url(#paint6_linear_641_5763)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7 27.9996C21.7435 27.9996 23.4 26.3431 23.4 24.2996C23.4 22.2562 21.7435 20.5996 19.7 20.5996C17.6565 20.5996 16 22.2562 16 24.2996C16 26.3431 17.6565 27.9996 19.7 27.9996Z",
    stroke: "url(#paint7_linear_641_5763)",
    strokeWidth: 0.04,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7 27.9996C21.7435 27.9996 23.4 26.3431 23.4 24.2996C23.4 22.2562 21.7435 20.5996 19.7 20.5996C17.6565 20.5996 16 22.2562 16 24.2996C16 26.3431 17.6565 27.9996 19.7 27.9996Z",
    fill: "url(#paint8_linear_641_5763)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1 14.3992C12.6405 14.3992 14.7 12.3397 14.7 9.79922C14.7 7.25871 12.6405 5.19922 10.1 5.19922C7.55949 5.19922 5.5 7.25871 5.5 9.79922C5.5 12.3397 7.55949 14.3992 10.1 14.3992Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1 14.3992C12.6405 14.3992 14.7 12.3397 14.7 9.79922C14.7 7.25871 12.6405 5.19922 10.1 5.19922C7.55949 5.19922 5.5 7.25871 5.5 9.79922C5.5 12.3397 7.55949 14.3992 10.1 14.3992Z",
    stroke: "url(#paint9_linear_641_5763)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1004 13.4996C12.1438 13.4996 13.8004 11.8431 13.8004 9.79961C13.8004 7.75616 12.1438 6.09961 10.1004 6.09961C8.05694 6.09961 6.40039 7.75616 6.40039 9.79961C6.40039 11.8431 8.05694 13.4996 10.1004 13.4996Z",
    stroke: "url(#paint10_linear_641_5763)",
    strokeWidth: 0.04,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1004 13.4996C12.1438 13.4996 13.8004 11.8431 13.8004 9.79961C13.8004 7.75616 12.1438 6.09961 10.1004 6.09961C8.05694 6.09961 6.40039 7.75616 6.40039 9.79961C6.40039 11.8431 8.05694 13.4996 10.1004 13.4996Z",
    fill: "url(#paint11_linear_641_5763)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4004 0.5V35.3",
    stroke: "url(#paint12_linear_641_5763)",
    strokeWidth: 0.19,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3998 19.0008C31.9403 19.0008 33.9998 16.9413 33.9998 14.4008C33.9998 11.8603 31.9403 9.80078 29.3998 9.80078C26.8593 9.80078 24.7998 11.8603 24.7998 14.4008C24.7998 16.9413 26.8593 19.0008 29.3998 19.0008Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3998 19.0008C31.9403 19.0008 33.9998 16.9413 33.9998 14.4008C33.9998 11.8603 31.9403 9.80078 29.3998 9.80078C26.8593 9.80078 24.7998 11.8603 24.7998 14.4008C24.7998 16.9413 26.8593 19.0008 29.3998 19.0008Z",
    stroke: "url(#paint13_linear_641_5763)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4002 18.0992C31.4436 18.0992 33.1002 16.4427 33.1002 14.3992C33.1002 12.3558 31.4436 10.6992 29.4002 10.6992C27.3567 10.6992 25.7002 12.3558 25.7002 14.3992C25.7002 16.4427 27.3567 18.0992 29.4002 18.0992Z",
    stroke: "url(#paint14_linear_641_5763)",
    strokeWidth: 0.04,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4002 18.0992C31.4436 18.0992 33.1002 16.4427 33.1002 14.3992C33.1002 12.3558 31.4436 10.6992 29.4002 10.6992C27.3567 10.6992 25.7002 12.3558 25.7002 14.3992C25.7002 16.4427 27.3567 18.0992 29.4002 18.0992Z",
    fill: "url(#paint15_linear_641_5763)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_641_5763",
    x1: 20.0002,
    y1: 28.3199,
    x2: 20.0002,
    y2: 39.1236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8811,
    stopColor: "#E9540E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_641_5763",
    x1: 19.6902,
    y1: 23.3108,
    x2: 20.2925,
    y2: 35.6261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#E9540E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_641_5763",
    x1: 20.0016,
    y1: 29.8861,
    x2: 20.0016,
    y2: 38.3961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_641_5763",
    x1: 19.8196,
    y1: 26.7884,
    x2: 20.2436,
    y2: 35.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#E9540E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#C2460C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#953609"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6D2707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#4B1B05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#301103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#1B0A02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0C0401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#030100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_641_5763",
    x1: "nan",
    y1: "nan",
    x2: "nan",
    y2: "nan",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E9540E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#CA490C",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#7C2D07",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_641_5763",
    x1: "nan",
    y1: "nan",
    x2: "nan",
    y2: "nan",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E9540E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#CA490C",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#7C2D07",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_641_5763",
    x1: 19.1037,
    y1: 29.4389,
    x2: 20.3772,
    y2: 19.8219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#061121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#E9540E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_641_5763",
    x1: 16.9572,
    y1: 26.4106,
    x2: 22.9206,
    y2: 21.8287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#061121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#E9540E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_641_5763",
    x1: 19.7719,
    y1: 23.1501,
    x2: 19.8459,
    y2: 19.7831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_641_5763",
    x1: 9.49728,
    y1: 14.9636,
    x2: 10.7613,
    y2: 5.34589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#061121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#E9540E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_641_5763",
    x1: 7.34639,
    y1: 11.9156,
    x2: 13.3157,
    y2: 7.34115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#061121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#E9540E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_641_5763",
    x1: 10.1627,
    y1: 8.66549,
    x2: 10.2366,
    y2: 5.29852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_641_5763",
    x1: "nan",
    y1: "nan",
    x2: "nan",
    y2: "nan",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E9540E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#CA490C",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#7C2D07",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_641_5763",
    x1: 28.8264,
    y1: 19.5552,
    x2: 30.0905,
    y2: 9.93774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#061121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#E9540E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_641_5763",
    x1: 26.6668,
    y1: 16.5132,
    x2: 32.6363,
    y2: 11.9391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#061121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#E9540E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_641_5763",
    x1: 29.4956,
    y1: 13.2606,
    x2: 29.5782,
    y2: 9.8981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_641_5763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock6Months);
export default __webpack_public_path__ + "static/media/lock-6-months.13e4a97131beb76e12a379c1efbbb269.svg";
export { ForwardRef as ReactComponent };